// import React from "react";
// import {
//   Row,
//   Col,
//   Card,
//   CardBody,
//   CardHeader,
//   CardTitle,
//   Button,
// } from "reactstrap";
// import { useForm } from "react-hook-form";
// import { useMutation } from "@apollo/client";
// import { CREATE_KPI_DURATION } from "@/GraphQL/Mutation";
// import FormField from "../FormField";
// import { SelectField } from "@/shared/components/form/Select";

// const monthOptions = [
//   { label: "January", value: 1 },
//   { label: "February", value: 2 },
//   { label: "March", value: 3 },
//   { label: "April", value: 4 },
//   { label: "May", value: 5 },
//   { label: "June", value: 6 },
//   { label: "July", value: 7 },
//   { label: "August", value: 8 },
//   { label: "September", value: 9 },
//   { label: "October", value: 10 },
//   { label: "November", value: 11 },
//   { label: "December", value: 12 },
// ];
// const CreateKpiDurationForm = () => {
//   const {
//     register,
//     handleSubmit,
//     control,
//     reset,
//     formState: { errors },
//   } = useForm();

//   const [createKpiDuration, { loading, error, data }] =
//     useMutation(CREATE_KPI_DURATION);
//   const onSubmit = async (formData) => {
//     try {
//       await createKpiDuration({
//         variables: {
//           start_date: parseInt(formData.start_date?.value),
//           end_date: parseInt(formData.end_date?.value),
//         },
//       });
//       reset();
//       alert("KPI Duration created successfully!");
//     } catch (err) {
//       console.error("Mutation error:", err);
//     }
//   };

//   return (
//     <Row className="justify-content-center mt-5">
//       <Col md={8} lg={6}>
//         <Card>
//           <CardHeader>
//             <CardTitle tag="h5" className="mb-0">
//               Create KPI Duration
//             </CardTitle>
//           </CardHeader>
//           <CardBody>
//             <form onSubmit={handleSubmit(onSubmit)}>
//               <Row>
//                 {/* Start Month */}
//                 <Col md={6}>
//                   <div className="form__form-group">
//                     <span className="form__form-group-label">Start Month</span>
//                     <div className="form__form-group-field">
//                       <FormField
//                         name="start_date"
//                         control={control}
//                         component={SelectField}
//                         options={monthOptions}
//                         placeholder="Select start month"
//                       />
//                     </div>
//                   </div>
//                 </Col>
//                 <Col md={6}>
//                   <div className="form__form-group">
//                     <span className="form__form-group-label">End Month</span>
//                     <div className="form__form-group-field">
//                       <FormField
//                         name="end_date"
//                         control={control}
//                         component={SelectField}
//                         options={monthOptions}
//                         placeholder="Select start month"
//                       />
//                     </div>
//                   </div>
//                 </Col>
//               </Row>

//               {/* Submit Button */}
//               <div className="d-flex justify-content-end mt-4">
//                 <Button color="primary" type="submit" disabled={loading}>
//                   {loading ? "Submitting..." : "Submit"}
//                 </Button>
//               </div>

//               {/* Mutation Feedback */}
//               {error && (
//                 <p className="text-danger mt-3">Error: {error.message}</p>
//               )}
//               {data && (
//                 <p className="text-success mt-3">KPI Duration created!</p>
//               )}
//             </form>
//           </CardBody>
//         </Card>
//       </Col>
//     </Row>
//   );
// };

// export default CreateKpiDurationForm;

import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "@apollo/client";
import DatePicker from "react-datepicker";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Row,
} from "reactstrap";
import { CREATE_KPI_DURATION } from "@/GraphQL/Mutation";
import moment from "moment";
import { useHistory } from "react-router";
import Swal from "sweetalert2";
import { GET_ALL_KPI_DURATION } from "@/GraphQL/Queries";

const CreateKpiDurationForm = () => {
  const history = useHistory();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  // const [createKpiDuration, { loading, error, data }] =
  //   useMutation(CREATE_KPI_DURATION);
  const [createKpiDuration, { loading, error, data }] = useMutation(
    CREATE_KPI_DURATION,
    {
      refetchQueries: [{ query: GET_ALL_KPI_DURATION }],
      awaitRefetchQueries: true,
    }
  );

  const onSubmit = async (formData) => {
    try {
      await createKpiDuration({
        variables: {
          start_date: moment(startDate).format("YYYY-MM-DD"),
          end_date: moment(endDate).format("YYYY-MM-DD"),
        },
      });
      reset();
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "KPI Duration created successfully!",
      });
      history.push("/department/kpi-duration-list");
    } catch (err) {
      console.error("Mutation error:", err);
    }
  };

  return (
    <Row className="justify-content-center mt-5">
      <Col md={8} lg={6}>
        <Card>
          <CardHeader>
            <CardTitle tag="h5" className="mb-0">
              Create KPI Duration
            </CardTitle>
          </CardHeader>
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">{`Date`}</span>
                    <div className="form__form-group-field ">
                      <DatePicker
                        dateFormat="MM/yyyy" // or "MMMM yyyy" for full month name
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        showMonthYearPicker
                        placeholderText="mm/yyyy"
                        className="form-control"
                      />
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">{`Date`}</span>
                    <div className="form__form-group-field ">
                      <DatePicker
                        dateFormat="MM/yyyy"
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        showMonthYearPicker
                        placeholderText="mm/yyyy"
                        className="form-control"
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="d-flex justify-content-end mt-4">
                <Button onClick={() => history.goBack()} color="danger">
                  Cancel
                </Button>
                <Button color="primary" type="submit" disabled={loading}>
                  {loading ? "Submitting..." : "Submit"}
                </Button>
              </div>

              {error && (
                <p className="text-danger mt-3">Error: {error.message}</p>
              )}
              {data && (
                <p className="text-success mt-3">KPI Duration created!</p>
              )}
            </form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default CreateKpiDurationForm;
